import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { TabView, TabPanel } from "primereact/tabview";
import Footer from "../../redesign/components/Footer";
import ManageServicesTabContent from "./ManageServicesTabContent";
import ManageProfileTabContent from "./ManageProfileTabContent";
// import "./ServiceProviderDashboard.css";
import Navbar from "../../redesign/components/Navbar";
import styles from "./ServiceProviderDashboard.module.css";
import { useDispatch, useSelector } from "react-redux";

import {
  getServiceProviderBusinessDetails,
  getServiceProviderProfile,
} from "../../Apiservices/Auth/servers/profileServer";
import {
  setBusinessData,
  setProfileData,
} from "../../store/providerProfileSlice";
import ManageOrdersTabContent from "./ManageOrdersTabContent";
import PriestMyServices from "./PriestMyServices";
import priestAvatarImg from "../../assets/images/icon 9/150x150 priest 1.png";

const ServiceProviderDashboard = () => {
  const dispatch = useDispatch();
  const [providerTypes, setproviderTypes] = useState();
  const [activeIndex, setActiveIndex] = useState(0);
  const [initialCategoryId, setInitialCategoryId] = useState(null);

  const profile = useSelector((state) => state.providerProfile?.profile);
  const firstName = profile?.firstName || "vinay";

  useEffect(() => {
    console.log("Use effect iscalled");
    const fetchDataIfNeeded = async () => {
      try {
        console.log("got here")
        const profile = await getServiceProviderProfile();
        setproviderTypes(profile.providerTypes[0]?.type);
        console.log("providerTypes", profile.providerTypes[0]?.type);
        dispatch(setProfileData(profile));


      } catch (err) {
        console.error("Error setting profile data", err);
      }

      try {
        const business = await getServiceProviderBusinessDetails();
        dispatch(setBusinessData(business));
      } catch (err) {
        console.error("Error setting business data", err);
      }
    };

    fetchDataIfNeeded();
  }, [dispatch]);
  const [activeServiceType, setActiveServiceType] = useState(null);

  useEffect(() => {
    console.log("activeServiceType changed =>", activeServiceType);
  }, [activeServiceType]);

  console.log("activeServiceType", activeServiceType)

  const isPriest = providerTypes?.toLowerCase() === "priest";

  const handleEditService = (categoryId) => {
    setInitialCategoryId(categoryId);
    setActiveIndex(0); // Switch to "Create" tab
  };

  const handleClearInitialCategory = () => {
    setInitialCategoryId(null);
  };

  return (
    <div className={styles.dashboardWrapper}>
      <Navbar />
      <div style={{ padding: '16px 24px' }}><Link to="/service-provider/calendar">Calendar</Link></div>
      <main className={`${styles.mainContent} ${activeServiceType === "Priest" ? styles.rentalsActive : ""
        }`}>
        {isPriest && (
          <div className={styles.greetingHeader}>
            <img src={priestAvatarImg} alt="Priest Avatar" className={styles.priestAvatar} />
            <div className={styles.greetingText}>
              <h1>Hi {firstName}</h1>
              <p>Create your puja services with pricing.</p>
            </div>
          </div>
        )}
        <div className={styles.thCustomTabWrapper}>
          {isPriest ? (
            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
              <TabPanel header="Create">
                <ManageServicesTabContent
                  onActiveTypeChange={setActiveServiceType}
                  initialCategoryId={initialCategoryId}
                  onClearInitialCategory={handleClearInitialCategory}
                />
              </TabPanel>
              <TabPanel header="My Services">
                <PriestMyServices onEditService={handleEditService} />
              </TabPanel>
              <TabPanel header="My Orders">
                <ManageOrdersTabContent onActiveTypeChange={setActiveServiceType} />
              </TabPanel>
              <TabPanel header="My Account">
                <ManageProfileTabContent />
              </TabPanel>
            </TabView>
          ) : (
            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
              <TabPanel
                header={
                  providerTypes?.toLowerCase() === "catering"
                    ? "Manage Menu" 
                    : providerTypes?.toLowerCase() === "venue"
                    ? "Manage Venue"
                    : providerTypes?.toLowerCase() === "helper"
                      ? "Manage Helper"
                      : "Manage Services"
                }>
                <ManageServicesTabContent onActiveTypeChange={setActiveServiceType} />
              </TabPanel>

              <TabPanel header="Manage Orders">
                <ManageOrdersTabContent onActiveTypeChange={setActiveServiceType} />
              </TabPanel>

              <TabPanel header="My Account">
                <ManageProfileTabContent />
              </TabPanel>
            </TabView>
          )}
        </div>
      </main>
      <Footer></Footer>
    </div>
  );
};

export default ServiceProviderDashboard;

